import { DayPickerProps } from '@daypicker/react'

import { getToday } from '../../../../../utils/extendedDayjs'
import { AstraButton } from '../../../AstraButton/AstraButton'

export type TodayButtonProps = {
    showTodayButton?: boolean
    onTodayButtonClick?: () => void
    todayButtonLabel?: string
} & Pick<DayPickerProps, 'onMonthChange' | 'today'>

export const TodayButton = ({ onMonthChange, onTodayButtonClick, showTodayButton, today, todayButtonLabel }: TodayButtonProps) => {
    if (!showTodayButton) {
        return null
    }

    const handleOnTodayButtonClick = () => {
        onMonthChange?.(today || getToday().toDate())
        onTodayButtonClick?.()
    }

    return <AstraButton fullWidth label={todayButtonLabel || 'I dag'} variant="secondary" onClick={handleOnTodayButtonClick} />
}
